// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YtuX","content":"styles_content__2Gx_a"};